import { render, staticRenderFns } from "./componentsdzk.vue?vue&type=template&id=15f3f0b4&scoped=true"
import script from "./componentsdzk.vue?vue&type=script&lang=js"
export * from "./componentsdzk.vue?vue&type=script&lang=js"
import style0 from "./componentsdzk.vue?vue&type=style&index=0&id=15f3f0b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3f0b4",
  null
  
)

export default component.exports